// Dono: gap-server (H11, lacuna #25). Bloco "Encerrar conta" de /conta: diálogo modal com o e-mail da conta digitado,
// DELETE /v1/me e limpeza da cópia deste aparelho. O servidor corta todos os acessos na hora e apaga tudo em até 30 dias.
import "../../styles/delete-account.css";
import { useEffect, useRef, useState } from "preact/hooks";
import { clearLocalData } from "../../data/index.ts";
import { me, save, showModal, store } from "../state.ts";

type Step = "ask" | "busy" | "done";

export function DeleteAccount() {
  const m = me.value!;
  const dialog = useRef<HTMLDialogElement>(null);
  const close = useRef<HTMLButtonElement>(null);
  const [step, setStep] = useState<Step>("ask");
  const [typed, setTyped] = useState("");
  const [error, setError] = useState("");
  const online = store.status.value.online;
  const typedOk = typed.trim().toLowerCase() === m.email.toLowerCase();
  useEffect(() => void (step === "done" && close.current?.focus()), [step]);

  const open = () => {
    setTyped("");
    setError("");
    showModal(dialog.current!);
  };
  const submit = async (e: Event) => {
    e.preventDefault();
    if (!typedOk || step !== "ask") return;
    setStep("busy");
    setError("");
    try {
      const res = await fetch("/v1/me", { method: "DELETE", headers: { "content-type": "application/json" }, body: JSON.stringify({ confirm: typed }) });
      if (!res.ok) throw new Error(((await res.json().catch(() => null)) as { title?: string } | null)?.title ?? `Erro ${res.status}.`);
    } catch (err) {
      setStep("ask");
      setError(err instanceof TypeError ? "Sem conexão com o servidor. Nada foi apagado." : `Não deu para encerrar: ${(err as Error).message}`);
      return;
    }
    // A resposta já apagou o cookie e o cache (Clear-Site-Data); aqui sai a réplica deste aparelho.
    save("faig.me", null);
    await store.stop().catch(() => {});
    await clearLocalData(m.id).catch(() => {});
    setStep("done");
  };

  return (
    // Na linha de baixo da página, à esquerda de "Sair" e "Exportar" (o mesmo lugar da referência).
    <div class="del-zone">
      <p class="del-zone-row">
        <span class="del-zone-label" id="del-zone-label">
          Zona de risco:
        </span>
        <button type="button" class="del-open" aria-describedby="del-zone-label" disabled={!online} onClick={open}>
          Encerrar e apagar minha conta
        </button>
      </p>
      {!online && <p class="acc-note">Encerrar a conta precisa de conexão.</p>}

      {/* Encerrada: fechar (Esc ou botão) leva à tela de entrada. Enviando: Esc não fecha. */}
      <dialog
        ref={dialog}
        id="del-account"
        class="acc-confirm del-confirm"
        aria-labelledby="del-title"
        aria-describedby="del-text"
        onClose={() => step === "done" && location.reload()}
        onCancel={(e) => step === "busy" && e.preventDefault()}
        onClick={(e) => e.target === e.currentTarget && step === "ask" && e.currentTarget.close()}
      >
        {step === "done" ? (
          <div class="acc-confirm-box">
            <h2 id="del-title">Conta encerrada</h2>
            <div id="del-text" class="acc-confirm-text">
              <p>Você saiu deste aparelho e dos outros. Em até 30 dias, nada da conta fica nos nossos servidores.</p>
            </div>
            <div class="acc-confirm-actions">
              <button ref={close} type="button" class="acc-btn primary" onClick={() => location.reload()}>
                Fechar
              </button>
            </div>
          </div>
        ) : (
          <form class="acc-confirm-box" onSubmit={submit}>
            <h2 id="del-title">Encerrar a conta?</h2>
            <div id="del-text" class="acc-confirm-text">
              <p>
                Some tudo: cards, arquivos, etiquetas, coleções e aparelhos pareados. Você sai de todos os aparelhos agora, e não dá para desfazer.
              </p>
              <p>Quer guardar uma cópia? Cancele e use “Exportar .zip” antes.</p>
            </div>
            <label class="del-label" for="del-email">
              Para confirmar, digite o e-mail da conta: <strong>{m.email}</strong>
            </label>
            <input
              id="del-email"
              class="del-input"
              type="email"
              autocomplete="off"
              spellcheck={false}
              value={typed}
              aria-invalid={error ? true : undefined}
              aria-describedby="del-error"
              onInput={(e) => setTyped(e.currentTarget.value)}
            />
            <p id="del-error" class="del-error" role="alert">
              {error}
            </p>
            <div class="acc-confirm-actions">
              <button type="button" class="acc-btn" autofocus disabled={step === "busy"} onClick={() => dialog.current?.close()}>
                Cancelar
              </button>
              <button type="submit" class="acc-btn del-go" disabled={!typedOk || step === "busy"} aria-busy={step === "busy"}>
                {step === "busy" ? "Encerrando…" : "Encerrar conta"}
              </button>
            </div>
          </form>
        )}
      </dialog>
    </div>
  );
}
